export default __webpack_public_path__ + "static/media/icon-out-network.de06043c.svg";